<div class="header-container">
  <div class="logo-container">
    <span (click)="goToHome()"><img class="img-logo" [src]="imagePath" alt="Logo"></span>
  </div>
  <div class="menu-hamburger">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
  </div>

  <div class="category-search">
    <div class="md-form form-group w-100 btn-group">
      <div class="dropdown dropdown-category">
        <div class="container">
          <div class="row">
            <div class="dropdown">
              <div class="btn-group">
                <button ng-mouseleave="AppComponent.mouseUpCategory=false" id="dLabel" role="button"
                  data-toggle="dropdown" class="btn btn-primary dropdown-toggle" (click)="clickCategory()"
                  data-target="#" href="/page.html"
                  [ngStyle]="getButtonStyle()">
                  <span class="text-btn-categoria">Categorias</span> <span class="caret"></span>
                </button>
                <ultra-category-menu id="menu"></ultra-category-menu>
              </div>
            </div>
          </div>
        </div>
      </div>
      <form [formGroup]="form" style="width: 100%;">
        <input type="text" class="form-control" placeholder="Buscar produto por Nome" (keyup)="pressedButton($event)"
          (click)="hideSidebar()" usd-only formControlName="search" (paste)="onPaste($event)">
      </form>
    </div>
  </div>

  <div class="row">
    <nb-actions size="medium">
      <nb-action class="control-item item-cart" (click)="checkoutNavigate()" badgeStatus="danger"
        [badgeText]="this.cartService.cartSize" icon="shopping-cart-outline">
      </nb-action>
    </nb-actions>
    <div class="dropdown">
      <i class="fas fa-chevron-down" style="color: white;line-height: 6;"></i>
      <button class="dropbtn">{{ getUserName() }}</button>
      <div class="dropdown-content">
        <a (click)="goToOrder()"><nb-icon class="menu-icon" icon="file-text-outline"></nb-icon>
          <p>Pedidos</p>
        </a>
        <a (click)="goToSettings()" *ngIf="authService.isAdmin()"><nb-icon class="menu-icon"
            icon="settings-outline"></nb-icon>
          <p>Configurações</p>
        </a>
        <a (click)="leaveSession()"><nb-icon class="menu-icon" icon="log-out-outline"></nb-icon>
          <p>Sair</p>
        </a>
      </div>
      <nb-user id="user-menu" size="medium" color="#ffffff" [name]="getUserName()" onlyPicture>
      </nb-user>
    </div>
  </div>
</div>